import axios from "axios";
import Vue from "vue";

const URL = process.env.VUE_APP_API;

const FETCH_ALL_USERS_SUCCESS = "FETCH_ALL_USERS_SUCCESS";

const defaultState = {
  users: [],
  loading: false,
};
const mutations = {
  [FETCH_ALL_USERS_SUCCESS](state, payload) {
    Vue.set(state, "users", payload);
  },
  setUsersLoading(state, val) {
    state.loading = val;
  },
};

const actions = {
  fetchAllUsers({ commit }) {
    return new Promise(async (resolve) => {
      commit("setUsersLoading", true);
      let users = [];
      
      // while (users.length === 0 || users.length % 50 === 0) {
        const res = await axios.get(`${URL}/users`);
      //   if (res.data.users.length === 0) {
      //     break;
      //   }
        users = users.concat(res.data.users);
      //   i++;
      // }

      users.sort((a, b) =>
        a.email < b.email ? -1 : b.email < a.email ? 1 : 0
      );

      commit(FETCH_ALL_USERS_SUCCESS, users);
      commit("setUsersLoading", false);
      resolve(users);
    });
  },
};

const getters = {
  getUsersState: (state) => {
    return () => state;
  },
};

export default {
  state: defaultState,
  getters,
  actions,
  mutations,
};
